<div class="payment-failed-container">
  <i class="icon-receipt-failed"></i>
  <h1>{{'payment.failed.content.msg' | translate}}</h1>
</div>